import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'bn-care-plan-editor-row',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './care-plan-editor-row.component.html',
  styleUrl: './care-plan-editor-row.component.scss',
})
export class CarePlanEditorRowComponent {
  readonly icon = input.required<string>();
  readonly label = input.required<string>();
  readonly inputId = input<string | null>(null);
  readonly required = input(false);
}
